import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-other-employees',
  templateUrl: './psa-other-employees.component.html',
  styleUrls: ['./psa-other-employees.component.css']
})
export class PsaOtherEmployeesComponent implements OnInit {
  title="Other Employee Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-other-employees/psa-other-employees.component.ts